document.addEventListener('DOMContentLoaded', function () {

    class CountdownTimer extends HTMLElement {
        constructor() {
            super();
            this.init();
        }

        init() {
            const targetDateAttribute = this.getAttribute("data-target-date");
            const targetDate = new Date(targetDateAttribute).getTime();
            const countdownContainer = this.querySelector(".countdown-container");

            if (!countdownContainer) {
                console.error("Countdown container not found.");
                return;
            }

            const intervalId = setInterval(() => {
                const currentDate = new Date().getTime();
                const timeRemaining = targetDate - currentDate;

                if (timeRemaining > 0) {
                    countdownContainer.style.display = "block";
                }

                const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
                const hours = Math.floor(((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + (24 * days));
                const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

                if (hours >= 1) {
                    this.updateCountdownElement(".hours", `${hours}h`);
                }
                this.updateCountdownElement(".minutes", `${minutes}m`);
                this.updateCountdownElement(".seconds", `${seconds}s`);

                if (timeRemaining < 0) {
                    clearInterval(intervalId);
                    countdownContainer.style.display = "none";
                }
            }, 1000);
        }

        updateCountdownElement(selector, content) {
            const element = this.querySelector(selector);
            if (element) {
                element.innerHTML = content;
            }
        }
    }

    customElements.define('countdown-time', CountdownTimer);
});